export const BASE = "https://api.pressione.co.kr";
export const BASE_SOCKET = "https://api.pressione.co.kr";
